module.exports = require("vuetify/lib/components/VImg");